// extracted by mini-css-extract-plugin
export default {"form":"CreateCourse_form__aUi6v","formInputBlock":"CreateCourse_formInputBlock__UUNlM","formInput":"CreateCourse_formInput__dfZcJ"};